var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#181B1E"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.285 12a7.286 7.286 0 1 0-14.571 0a7.286 7.286 0 0 0 14.571 0m-.857 0a6.429 6.429 0 1 0-12.857 0a6.429 6.429 0 0 0 12.857 0",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.142 16.282V7.727a5.8 5.8 0 0 1 1.286-.87l5.143 8.014V6.858c.45.236.921.557 1.286.904v8.525a6 6 0 0 1-1.286.857l-5.143-8.04v8.04a6.8 6.8 0 0 1-1.286-.861"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNym);
export default __webpack_public_path__ + "static/media/nym.8636d2130cee1da4be1bf33a09050aea.svg";
export { ForwardRef as ReactComponent };